var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-responsive",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"grid"},[_vm._l((_vm.staffs),function(item,i){return _c('div',{key:item.id,staticClass:"grid-item",style:({
        backgroundColor:
          _vm.currentIndex === i && _vm.highlight
            ? '#b4ded5'
            : _vm.$store.getters.printStaffColor(item),
      }),on:{"click":function($event){return _vm.handleClickItem(item, i)}}},[_vm._v(" "+_vm._s(item.ref)),_c('br')])}),(!_vm.staffs.length)?_c('div',{directives:[{name:"translate",rawName:"v-translate"}],staticClass:"text-result"},[_vm._v(" No results found! ")]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }